import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TCIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TC" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.868L8.245.944 9.29-.346 7.172-.638 3.882 2.13 1.233 3.997-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.504L8.914-.467H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346.228-.638l3.29 2.768 2.649 1.866L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.936-1.01.504-4.018-3.459-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.971Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
